import React from 'react'
import { Link } from 'react-router-dom'
import './index.scss'
import { reportFn } from '@feedback/utils/util'
interface Props {
  questionList: any[]
}
function QuestionList({ questionList }: Props) {
  return (
    <div className='c-question-list'>
      <ul className='question-list'>
        {questionList.map((item, index) => (
          <li
            className={`question-item ${index % 2 === 0 ? 'left' : 'right'}`}
            key={item._id}
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            <Link
              onClick={() => {
                reportFn({ parm1: 1, parm2: 1, parm6: item._id })
              }}
              to={`/v1/questionDetail?faq_id=${item._id}`}
            >
              <div className='content-box'>{item.question}</div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default QuestionList
